import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AlgoliaInstantSearch from './AlgoliaInstantSearch';
import './FeaturedProfiles.scss';

class FeaturedProfiles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: props.email,
    };

    this.handleUserSignUp = this.handleUserSignUp.bind(this);
    this.emailStatus = this.emailStatus.bind(this);
  }

  handleUserSignUp(userEmail) {
    this.setState({ email: userEmail });
  }

  emailStatus() {
    const { email } = this.state;

    return email;
  }

  render() {
    const {
      userData, indexName, agAppID, publicKey, csrfToken, cloraEmployer,
      googleOmniauthUrl, msOmniauthUrl, signInUrl, initialFilters,
    } = this.props;

    return (
      <AlgoliaInstantSearch
        indexName={indexName}
        agAppID={agAppID}
        publicKey={publicKey}
        handleRegister={this.handleUserSignUp}
        getEmailStatus={this.emailStatus}
        csrfToken={csrfToken}
        userData={userData}
        cloraEmployer={cloraEmployer}
        googleOmniauthUrl={googleOmniauthUrl}
        msOmniauthUrl={msOmniauthUrl}
        signInUrl={signInUrl}
        initialFilters={initialFilters}
      />
    );
  }
}

FeaturedProfiles.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  email: PropTypes.string,
  userData: PropTypes.shape({}),
  indexName: PropTypes.string.isRequired,
  agAppID: PropTypes.string.isRequired,
  publicKey: PropTypes.string.isRequired,
  cloraEmployer: PropTypes.bool,
  googleOmniauthUrl: PropTypes.string.isRequired,
  msOmniauthUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
  initialFilters: PropTypes.shape({}),
};

FeaturedProfiles.defaultProps = {
  email: null,
  userData: {},
  cloraEmployer: false,
  initialFilters: null,
};

export default FeaturedProfiles;
